import { combineReducers } from 'redux';

import depreciation from 'reports/reducers/depreciation_report_reducers';
import disabled from 'reports/reducers/disabled_report_reducers';
import employeesAssets from 'reports/reducers/employees_assets_report_reducers';
import historics from 'reports/reducers/historics_report_reducers';
import ins_outs from 'reports/reducers/ins_outs_report_reducers';

export default combineReducers({
  depreciation,
  disabled,
  employeesAssets,
  historics,
  ins_outs,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/reducers/index.js